<template>
  <div class="mb-1">
    <span class="align-middle">
      <strong>
        <div class="edit-profile-container">

          <feather-icon
            :icon="icon"
            size="20"
            class="mr-50"
          />

          <template v-if="isEdit">
            <b-form
              class="edit-profile-form"
              @submit.prevent="submitEdit"
            >
              <b-form-input
                v-model="value"
                reqired
                size="sm"
                :type="datatype"
                required
                :placeholder="placeholder"
              />
              <div class="edit-button-container">
                <label
                  v-b-tooltip.hover
                  title="Cancel"
                  for="cancel-button"
                  class="edit-button"
                >
                  <feather-icon
                    icon="XIcon"
                    size="20"
                  />
                </label>
                <label
                  v-b-tooltip.hover
                  title="Save"
                  for="submit-button"
                  class="edit-button"
                >
                  <feather-icon
                    icon="CheckIcon"
                    size="20"
                  />
                </label>

                <b-button
                  id="cancel-button"
                  style="display: none"
                  size="sm"
                  @click="handleCancel"
                >Cancel</b-button>
                <b-button
                  id="submit-button"
                  style="display: none"
                  size="sm"
                  type="submit"
                >Save</b-button>
              </div>
            </b-form>
          </template>

          <template v-else>
            <div class="edit-profile-view">
              <p>
                {{ value || emptyLabel }}
              </p>
              <div
                v-b-tooltip.hover
                class="clickable-icon"
                title="Edit"
                @click="isEdit = true"
              >
                <feather-icon
                  icon="Edit2Icon"
                  size="20"
                  class="mr-50"
                />
              </div>
            </div>
          </template>
        </div>
      </strong>
    </span>
  </div>
</template>
<script>
import { BForm, BFormInput, BButton } from 'bootstrap-vue'
import CustomerProfileRepository from '@/repositories/Api/CustomerProfileRepository'

export default {
  name: 'GEditableProfileInfo',
  components: {
    BForm,
    BFormInput,
    BButton,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    customerId: {
      type: String,
      default: '',
    },
    datatype: {
      type: String,
      default: 'text',
    },
    defaultValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Enter information',
    },
    infoType: {
      type: String,
      default: '',
    },
    emptyLabel: {
      type: String,
      default: 'No information',
    },
    defaultForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isEdit: false,
      value: this.defaultValue,
      lastSavedValue: this.defaultValue,
    }
  },
  computed: {
    GetKeyForUpdate: {
      get() {
        return this.infoType
      },
    },
  },
  watch: {
    defaultValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.value = newVal
      }
    },
  },
  methods: {
    submitEdit() {
      // this.$emit('submit', this.value)
      CustomerProfileRepository.UpdateProfile(
        {
          ...this.defaultForm,
        },
        this.customerId,
      )
        .then(response => {
          // this.$emit('submit', this.value)
          console.log(response.data)
          this.isEdit = false
        })
        .catch(error => {
          console.log(error)
        })
      this.isEdit = false
      this.lastSavedValue = this.value
    },
    handleCancel() {
      this.isEdit = false
      this.value = this.lastSavedValue
    },
  },
}
</script>
